import type { FaireProductEntity } from "../../entity_types/product";

export const p_ymvvfuynvw: FaireProductEntity = {
  token: "p_ymvvfuynvw",
  type: "product",
  name: "Eucalyptus Spa Night Bath Salt Soaks, Self Care Relaxation",
  brandName: "Atticwear",
  imageUrl:
    "https://cdn.faire.com/fastly/4ad6ef54c1badd89397eccb83784abccb329a37322c13303bc74f6c835bbd824.jpeg",
  priceDollars: 10,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/1e77b6408444b2bad51b96d078d844a94fb7774c95c1a0c9774049e82abaf23e.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
